import { render, staticRenderFns } from "./InadimplenciaPerformance.vue?vue&type=template&id=927c1362&scoped=true"
import script from "./InadimplenciaPerformance.vue?vue&type=script&lang=js"
export * from "./InadimplenciaPerformance.vue?vue&type=script&lang=js"
import style0 from "./InadimplenciaPerformance.vue?vue&type=style&index=0&id=927c1362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927c1362",
  null
  
)

export default component.exports